/* Rquiere de mixin.js */

var typeProduct = {
	data () {
		return {
			listTypesProduct: [],
			methodsTypeProduct: {
				get: 'typesProduct',
				show: 'typeProduct/',
			},
			paginationTypesProduct: [],
			searchTypesProduct: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllTypesProduct(page = 1) {
			let parameters = '?search=' + this.searchTypesProduct + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methodsTypeProduct.get + parameters, 'GET', 'getAllTypesProductResult')
        },
		getAllTypesProductResult(response) {
            if(response.data.success) {
                this.listTypesProduct = response.data.data
                this.paginationTypesProduct = response.data.paginate    
            }
            this.getAllTypesProductResultLocal(response)
		},
        getAllTypesProductResultLocal(response) {
            console.log('getAllTypesProductResultLocal no desarrollado', response)
        },
		getTypeProduct(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsTypeProduct.show + id, 'GET', 'getTypeProductResult')
		},
        getTypeProductResult(response) {
            this.getTypeProductResultLocal(response)
        },
        getTypeProductResultLocal(response) {
            console.log('getTypeProductResultLocal no está desarrollado', response)
        },
	},
};

export default typeProduct;